// Map contenant les différents fichiers de traductions chargés
const translationList = new Map();
// langue courante du Kore
let language = "en";

// wrapper qui va aller chercher les bonnes traductions en mémoire ou les créer
const translations = (traductionName) => {
  const name = traductionName || "Kore";
  const trads = new Map();

  const mapTranslations = ({ keys, component, index, translationName }) => {
    const componentKeys = Object.keys(component);
    let currentLanguage = keys[index];
    const folders = currentLanguage.replace(/\/$/, "").split("/");

    currentLanguage = folders[folders.length - 2];

    componentKeys.map((keyName) => {
      const keyNameString = keyName.toString();
      const obj = trads.get(keyNameString) || {};

      obj[currentLanguage] = component[keyName];
      trads.set(keyNameString, obj);
    });

    translationList.set(translationName, trads);
  };

  const addTranslations = (requireContext) => {
    if (!translationList.get(name)) {
      const keys = requireContext.keys();

      keys.map(requireContext).map((component, index) => {
        mapTranslations({ keys, component: component.default, index, translationName: name });
      });
    }
  };

  const addTranslation = (keys, requireContext, pluginName) => {
    keys.map(requireContext).map((component, index) => {
      mapTranslations({ keys, component: component.default, index, translationName: pluginName });
    });
  };

  const getLanguage = () => language;

  const setLanguage = (planguage) => {
    if (planguage) language = planguage;
  };

  const _ = (text: string) => {
    let trans = translationList.get(name);

    let trad = trans?.get(text);

    if (!trad || !trad[language]) {
      trans = translationList.get("Kore");

      if (trans) trad = trans.get(text);
    }

    if (trad && trad[language]) return trad[language];

    return text;
  };

  return {
    addTranslation,
    addTranslations,
    setLanguage,
    getLanguage,
    _
  };
};

export default translations;
